// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPurchaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPurchase";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

/* Store Custom Code - Start */
import mapPurchaseItems from "@store/Framework/GoogleAnalytics/mappers/mapPurchaseItems";
import { useWebsite } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useBillToState } from "@toolkit/Framework/Store/Data/BillTos/BillTosHooks";
import constants from "@store/constants";
/* Store Custom Code - End */

const useTrackPurchase = (
    parameters: PartialSpecific<TrackPurchaseParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    /* Store Custom Code - Start */
    const website = useWebsite();
    const billTo = useBillToState(options?.cart?.billToId).value;
    const siteKey = website.key;
    const customerType =
        billTo?.properties?.customerType?.toUpperCase() === constants.customerType.b2b
            ? constants.customerType.b2b
            : constants.customerType.b2c;

    const eventListParameters = ga.use.eventListParameters(options);

    const baseHookParameters: TrackPurchaseParameters = {
        ...eventListParameters,
        ...parameters,
    };

    const hookParameters: TrackPurchaseParameters = {
        ...baseHookParameters,
        customer_type: customerType,
        items: mapPurchaseItems(parameters, options, eventListParameters),
        site_key: siteKey,
    };
    /* Store Custom Code - End */

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackPurchaseParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.purchase({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};
export default useTrackPurchase;
